import commonUtil from '../../../../../utils/commonUtil';

export const GET_CLOSING_GIFT_PRICE_RANGE = 'GET_CLOSING_GIFT_PRICE_RANGE';
export const GET_CLOSING_GIFT_PRICE_RANGE_SUCCESS = 'GET_CLOSING_GIFT_PRICE_RANGE_SUCCESS';
export const GET_CLOSING_GIFT_PRICE_RANGE_FAIL = 'GET_CLOSING_GIFT_PRICE_RANGE_FAIL';

export const CLOSINGGIFTDETAILS_LOAD = 'CLOSINGGIFTDETAILS_LOAD';
export const CLOSINGGIFTDETAILS_LOAD_SUCCESS = 'CLOSINGGIFTDETAILS_LOAD_SUCCESS';
export const CLOSINGGIFTDETAILS_LOAD_FAIL = 'CLOSINGGIFTDETAILS_LOAD_FAIL';

const CLOSING = 'closing';
const GETCLOSINGGIFTPRICERANGEURL = '/api/EditEvent/getClosingGiftPriceRange';
const GETOPENINGORCLOSINGGIFTURL = '/api/EditEvent/getOpeningOrClosingGiftForEvent';

export function handleGetClosingGiftPriceRange(eventID) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventID;
  return {
    types: [GET_CLOSING_GIFT_PRICE_RANGE, GET_CLOSING_GIFT_PRICE_RANGE_SUCCESS, GET_CLOSING_GIFT_PRICE_RANGE_FAIL],
    promise: client => client.post(GETCLOSINGGIFTPRICERANGEURL, { data: payload }),
  };
}

// for get Closing Gift Details For Event
export function handleGetGiftClosingDetails(eventId) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventId;
  payload.type = CLOSING;
  return {
    types: [CLOSINGGIFTDETAILS_LOAD, CLOSINGGIFTDETAILS_LOAD_SUCCESS, CLOSINGGIFTDETAILS_LOAD_FAIL],
    promise: client => client.post(GETOPENINGORCLOSINGGIFTURL, { data: (payload) }),
  };
}
